import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface HybridKeksLabelsState {
  isLoading: boolean
  data: string[] | null
  error: string | null
  httpStatus: number | null
}

const initialState: HybridKeksLabelsState = {
  isLoading: false,
  data: null,
  error: null,
  httpStatus: 0
}

export const hybridKeksLabelsSlice = createSlice({
  name: 'hybridKeksLabels',
  initialState,
  reducers: {
    hybridKeksLabelsLoadingAction: (): HybridKeksLabelsState => ({
      isLoading: true,
      data: [],
      error: null,
      httpStatus: 0
    }),
    hybridKeksLabelsUpdateAction: (state, action: PayloadAction<{ data: string[], httpStatus: number }>): HybridKeksLabelsState => ({
      isLoading: false,
      data: action.payload.data ?? [],
      error: null,
      httpStatus: action.payload.httpStatus
    }),
    hybridKeksLabelsErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>): HybridKeksLabelsState => ({
      isLoading: false,
      data: null,
      error: action.payload.errorMessage,
      httpStatus: action.payload.httpStatus
    })
  }
})

export const { hybridKeksLabelsLoadingAction, hybridKeksLabelsUpdateAction, hybridKeksLabelsErrorAction } = hybridKeksLabelsSlice.actions
export default hybridKeksLabelsSlice.reducer
